export enum AddFilesProcessStatus {
  READ_FILES = 'Read Files',
  VALIDATING_DATA = 'Validating Data',
}
